import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { convertToImageKitUrl } from '@lemonadefashion/imagekit';
import { elementSizePolicyPropType } from '../../element_sizing/size_policy_type';
import { sourceImageSizeSpecPropType } from '../../element_sizing/source_image_size_spec_type';
import { getSizingCSS, getSizingCSSForImg } from '../../element_sizing/css';
import { getImageKitSpecsForSourceImageSizeSpec } from '../../element_sizing/image_kit_specs';

export const getImageUrl = (sourceImageSizeSpec, imageRoute, breakpoints, breakpointFlags) => {
  const imageKitSpecs = getImageKitSpecsForSourceImageSizeSpec(breakpoints, breakpointFlags, sourceImageSizeSpec);
  return convertToImageKitUrl(imageRoute, imageKitSpecs);
};

const UIImage = (props) => (
  <UIImageRelativeContainer policy={props.imageSizePolicy} setMarginAuto={props.setMarginAuto}
    borderRadius={props.borderRadius}>
    <UIImageFallback bubbly={props.bubbly} fallbackTransparent={props.fallbackTransparent}
      borderRadius={props.borderRadius} />
    <UIImageElement alt={props.alt} policy={props.imageSizePolicy} bubbly={props.bubbly}
      borderRadius={props.borderRadius} fullHeight={props.fullHeight}
      src={getImageUrl(props.sourceImageSizeSpec, props.srcRoute, props.breakpoints, props.breakpointFlags)}
      backgroundColor={props.backgroundColor} padding={props.padding} />
    {props.imageOverlay && <UIImageElementOverLay imageOverlay={props.imageOverlay}
      policy={props.imageSizePolicy} bubbly={props.bubbly} borderRadius={props.borderRadius} />}
  </UIImageRelativeContainer>);

if (process.env.NODE_ENV !== 'production') {
  UIImage.propTypes = {
    imageSizePolicy: elementSizePolicyPropType.isRequired,
    sourceImageSizeSpec: sourceImageSizeSpecPropType.isRequired,
    breakpointFlags: PropTypes.arrayOf(PropTypes.bool.isRequired),
    breakpoints: PropTypes.arrayOf(PropTypes.number.isRequired),
    srcRoute: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    bubbly: PropTypes.bool,
    imageOverlay: PropTypes.string,
    setMarginAuto: PropTypes.bool,
    fallbackTransparent: PropTypes.bool,
    borderRadius: PropTypes.string
  };
}

UIImage.defaultProps = {
  bubbly: false,
  breakpointFlags: [],
  breakpoints: [],
  fallbackTransparent: false
};

const UIImageRelativeContainer = styled.div`
  position: relative;
  ${props => getSizingCSS(props.policy)};
  ${props => props.setMarginAuto && 'margin: auto'};
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}`};
`;

const UIImageFallback = styled.div`
  position: absolute;
  top: 2px; bottom: 2px; right: 2px; left: 2px;
  background: ${props => props.fallbackTransparent ? 'transparent' : '#f2f2f2'};
  z-index: 0;
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}`};
  ${props => props.bubbly && 'border-radius: 30px'};
`;

const UIImageElement = styled.img`
  ${props => getSizingCSSForImg(props.policy)};
  ${props => props.bubbly && 'border-radius: 30px'};
  ${props => props.fullHeight && 'height: 100% !important'};
  object-fit: ${props => props.fullHeight && 'cover'};
  position: relative;
  z-index: 2;
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}`}
  background-color: ${props => props.backgroundColor || 'transparent'};
  padding: ${props => props.padding || '0'};
`;

const UIImageElementOverLay = styled.div`
  position: absolute;
  top: 0; bottom: 0; right: 0; left: 0;
  background: ${props => props.imageOverlay ? props.imageOverlay : '#f2f2f2'};
  z-index: 4;
  ${props => getSizingCSSForImg(props.policy)};
  ${props => props.bubbly && 'border-radius: 30px'};
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}`};
`;

export default UIImage;
